import { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { useCommands } from '../api/commands';
import PageHeader from '../components/PageHeader';

export default function AdminUsers() {
  const { user } = useAuth();
  const cmd = useCommands();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [okMsg, setOkMsg] = useState('');

  async function load() {
    setLoading(true); setErr('');
    try {
      const data = await cmd.auth.listUsers();
      setUsers(Array.isArray(data) ? data : []);
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || 'Failed to load users');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function resetPassword(username) {
    if (!window.confirm(`Reset password for "${username}" back to "password"?`)) return;
    setErr(''); setOkMsg('');
    try {
      await cmd.auth.adminResetPassword(username);
      setOkMsg(`Password reset for ${username}.`);
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || 'Failed to reset password');
    }
  }

  if (user?.username !== 'admin' && user?.role !== 'admin') {
    return (
      <div className="container narrow">
        <div className="card"><div className="empty">Access denied.</div></div>
      </div>
    );
  }

  return (
    <div className="container narrow">
      <PageHeader
        eyebrow="Admin"
        title="Users"
        actions={<button className="btn secondary" onClick={load}>Reload</button>}
      />

      {(err || okMsg) && (
        <div className="page-alerts">
          {err   && <div className="alert error">{err}</div>}
          {okMsg && <div className="alert success">{okMsg}</div>}
        </div>
      )}

      <div className="card">
        {loading ? <div className="empty">Loading</div> : users.length === 0 ? (
          <div className="empty">No users found.</div>
        ) : (
          <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Role</th>
                <th className="actions"></th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id || u.username}>
                  <td className="cell-strong">{u.username}</td>
                  <td><span className={u.role === 'admin' ? 'badge info' : 'badge'}>{u.role}</span></td>
                  <td className="actions">
                    {u.username !== 'admin' && (
                      <button
                        className="btn secondary small"
                        onClick={() => resetPassword(u.username)}
                      >
                        Reset password
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>
    </div>
  );
}
